import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Loader from '../components/Loader';

import useFetchDommages from '../hooks/useFetchDommages';
import useFetchSites from '../hooks/useFetchSites';
import useFetchDeclarations from '../hooks/useFetchDeclarations';
// import useFetchDoxExt from '../hooks/useFetchDoxExt';
// import useFetchDocs from '../hooks/useFetchDocs';

import { formatDate, formatCurrency } from '../utils/Format';
import AutoResizeTextarea from '../utils/AutoResizeTextarea';

import SectionCard from '../utils/SectionCard';
import InfoItem from '../utils/InfoItem';

const Row = ({ children }) => (
    <div className="gap-6 grid grid-cols-1 lg:grid-cols-2">{children}</div>
);

const DommageDetails = () => {
    const { uuid } = useParams();

    const { dommage, fetchDommageByUUID } = useFetchDommages();
    const { site: siteDommage, fetchSiteByUUID } = useFetchSites();
    const { declaration: declaDommage, fetchDeclarationByUUID } = useFetchDeclarations();

    const [activeTab, setActiveTab] = useState('coord');

    useEffect(() => {
        if (uuid) {
            fetchDommageByUUID(uuid);
        }
    }, [uuid]);

    useEffect(() => {
        if (dommage && dommage.UUID_Declaration_) {
            fetchDeclarationByUUID(dommage.UUID_Declaration_);
        }
    }, [dommage]);

    useEffect(() => {
        if (declaDommage && declaDommage.UUID_Site_) {
            fetchSiteByUUID(declaDommage.UUID_Site_);
        }
    }, [declaDommage]);

    if (!dommage || !declaDommage || !siteDommage) {
        return <div class="flex flex-1 justify-center items-center"><Loader /></div>;
    }

    // console.log("Dommage chargé:", dommage);
    // console.log("Site chargé:", siteDommage);
    // console.log("Déclaration chargé:", declaDommage);

    return (

        <div class="flex-1 p-4 lg:p-8">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="flex items-center bg-gray-900 drop-shadow-xl mb-6 px-8 rounded-lg w-full h-20">
                            <div id="url" class="flex flex items-center gap-x-2 font-semibold text-gray-400 text-sm sm:text-lg">
                                <Link to="/sites" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Sites</Link>
                                <span class="cursor-default">/</span>
                                <Link to={"/sites/" + siteDommage.UUID_} class="hover:text-orange-600 transition hover:translate-y-[-2px] duration-300">
                                    {siteDommage.Nom}
                                </Link>
                                <span class="cursor-default">/</span>
                                <Link to="/declarations" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Delarations</Link>
                                <span class="cursor-default">/</span>
                                <Link to={"/declarations/" + declaDommage.UUID_} class="hover:text-orange-600 transition hover:translate-y-[-2px] duration-300">
                                    {declaDommage.Libelle ? `${declaDommage.Libelle.slice(0, 30)}${declaDommage.Libelle.length > 50 ? '...' : ''}` : 'Sans Libelle'}
                                </Link>
                                <span class="cursor-default">/</span>
                                <Link to="/dommages" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Dommages</Link>
                                <span class="cursor-default">/</span>
                                <Link to="" class="block text-orange-600 transition hover:translate-y-[-2px]">
                                    {dommage.Libelle ? `${dommage.Libelle.slice(0, 30)}${dommage.Libelle.length > 50 ? '...' : ''}` : 'Sans Libelle'}
                                </Link>
                            </div>
                        </div>

                        <div className="mx-auto w-full">
                            <div className="mb-4 border-gray-200 dark:border-gray-700 border-b">
                                <ul className="flex flex-wrap -mb-px" role="tablist">
                                    {[
                                        { id: 'coord', label: 'Coordonnées' },
                                        // { id: 'dommages', label: 'Dommages' },
                                        // { id: 'exp', label: 'Expertises' },
                                        // { id: 'docs', label: 'Documents Externes' },
                                    ].map((tab) => (
                                        <li key={tab.id} className="mr-2" role="presentation">
                                            <button
                                                className={`text-base font-semibold text-center py-4 px-4 rounded-t-lg border-b-5 ${activeTab === tab.id
                                                    ? 'text-orange-600 borde-2 border-orange-300 dark:text-white'
                                                    : 'text-orange-400 border-transparent hover:text-orange-500'
                                                    } transition duration-300 ease-in-out`}
                                                onClick={() => setActiveTab(tab.id)}
                                                type="button"
                                                role="tab"
                                                aria-controls={tab.id}
                                                aria-selected={activeTab === tab.id}
                                            >
                                                {tab.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div id="myTabContent">
                                {activeTab === 'coord' && (
                                    <div id="form-info" className="space-y-6 mx-auto">
                                        {/* Bandeau titre optionnel */}
                                        <div className="flex items-end gap-6 bg-white bg-gradient-to-tr from-orange-600 via-orange-500 to-orange-400 p-4 px-8 rounded-lg w-full text-white">
                                            <p className="space-x-2 font-bold text-2xl">
                                                <i className="fa-solid fa-house-crack fa-sm" />
                                                <span>Dommage</span>
                                            </p>
                                            <p className="space-x-2 font-medium text-sm">
                                                <i className="fa-solid fa-hashtag" />
                                                <span className="uppercase">{dommage?.CODE_CRAC}</span>
                                                {dommage?.Etat && <span className="font-bold">({dommage.Etat})</span>}
                                            </p>
                                        </div>

                                        {/* LIGNE 1 : Rappels Site / Rappels Déclaration */}
                                        <Row>
                                            <SectionCard title="Rappels Site" icon="fa-building">
                                                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                    <InfoItem label="Site Nom" value={siteDommage?.Nom} />
                                                    <InfoItem label="Entité / Région" value={siteDommage?.Entite} />
                                                    <InfoItem label="Société" value={siteDommage?.Societe} />
                                                    <InfoItem label="Domaine d’activité" value={siteDommage?.Etat} />
                                                    <InfoItem label="Code compta" value={siteDommage?.Code_compta} mono />
                                                    <InfoItem label="Date OS" value={formatDate(siteDommage?.Date_OS)} />
                                                    <InfoItem label="Date DOC" value={formatDate(siteDommage?.Date_DOC)} />
                                                    <InfoItem label="P.V. Réception" value={formatDate(siteDommage?.Date_PVRecep)} />
                                                </div>
                                            </SectionCard>

                                            <SectionCard title="Rappels Déclaration" icon="fa-file-shield">
                                                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                    <InfoItem label="Libellé" value={declaDommage?.Libelle} />
                                                    <InfoItem label="Type" value={declaDommage?.Type_Declaration} />
                                                    <InfoItem label="Code" value={declaDommage?.Code_Procedure} mono />
                                                    <InfoItem label="État" value={declaDommage?.Etat} />
                                                    <InfoItem label="Création" value={formatDate(declaDommage?.Date_creation)} />
                                                </div>
                                            </SectionCard>
                                        </Row>

                                        {/* LIGNE 2 : Détails / Pathologies */}
                                        <Row>
                                            <SectionCard title="Détails du Dommage" icon="fa-circle-info">
                                                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                    <InfoItem label="Libellé" value={dommage?.Libelle} />
                                                    <InfoItem label="Code CRAC" value={dommage?.CODE_CRAC} mono />
                                                    <InfoItem label="Type de Risque" value={dommage?.Type_Risque} />
                                                    <InfoItem label="État" value={dommage?.Etat} />
                                                    <InfoItem label="Date de création" value={formatDate(dommage?._Date_Crea)} />
                                                </div>
                                            </SectionCard>

                                            <SectionCard title="Pathologies identifiées" icon="fa-stethoscope">
                                                <div className="gap-2 grid grid-cols-1">
                                                    <ul className="pl-5 list-disc">
                                                        {[...Array(6).keys()].map(i => {
                                                            const k = `Cd_Patho_${i + 1}`;
                                                            return dommage?.[k] ? <li key={k}>{dommage[k]}</li> : null;
                                                        })}
                                                    </ul>
                                                </div>
                                            </SectionCard>
                                        </Row>

                                        {/* LIGNE 3 : Récapitulatif financier / Intervenants */}
                                        <Row>
                                            <SectionCard title="Récapitulatif financier" icon="fa-scale-balanced">
                                                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                    <InfoItem label="Provision Totale" value={formatCurrency(dommage?.Provision_TT)} />
                                                    <InfoItem label="Recours Total" value={formatCurrency(dommage?.Recours_TT)} />
                                                </div>
                                            </SectionCard>

                                            <SectionCard title="Intervenants & Références" icon="fa-user-tie">
                                                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                                                    <InfoItem label="Intervenant" value={dommage?.Intervenant_Nom || "N/A"} />
                                                </div>
                                            </SectionCard>
                                        </Row>

                                        {/* LIGNE 4 : Recours & Règlements */}
                                        <SectionCard title="État du recours & règlements" icon="fa-file-invoice-dollar">
                                            <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                                                <InfoItem label="Recours Prévu" value={formatCurrency(dommage?.Recours_PP)} />
                                                <InfoItem label="Règlement" value={formatCurrency(dommage?.Reglement)} />
                                                <InfoItem label="Règlement Date" value={formatDate(dommage?.Reglement_Date)} />
                                                <InfoItem label="Quitus Transmis" value={dommage?.Quitus_Transmis ? "Oui" : "Non"} />
                                            </div>
                                        </SectionCard>
                                    </div>
                                )}
                                {/* {activeTab === 'dommages' && (
									<ListDommage lstDommages={dommages}/>
								)}
								{activeTab === 'exp' && (
									<ListDoc lstDocs={lstDocs} type="Expertise"/>
								)} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default DommageDetails;